import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/station/co2.svg'
import _imports_1 from '@/assets/station/tree.svg'


const _withScopeId = n => (_pushScopeId("data-v-faf55226"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "energy-conversion-info" }
const _hoisted_2 = { class: "count-info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "当日充电能量数(kWh)", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "当日放电能量数(kWh)", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "当日减少碳排放量(kg)", -1))
const _hoisted_6 = { class: "energy-saving" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "累计减少碳排放量(kg)", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "累计减排的植树数量(棵)", -1))


import { GetEssEnergyConversionStatsReply } from '../types'

export default /*#__PURE__*/_defineComponent({
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data?: Partial<GetEssEnergyConversionStatsReply>
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", null, _toDisplayString(props.data?.dailyChargeEnergy?.toFixed(0) || 0), 1),
        _hoisted_3
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", null, _toDisplayString(props.data?.dailyDischargeEnergy?.toFixed(0) || 0), 1),
        _hoisted_4
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", null, _toDisplayString(props.data?.dailyReduceCarbon?.toFixed(0) || 0), 1),
        _hoisted_5
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("div", null, _toDisplayString(props.data?.cumulativeReduceCarbon?.toFixed(0) || 0), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_9,
        _hoisted_10,
        _createElementVNode("div", null, _toDisplayString(props.data?.equivalentPlantingTrees?.toFixed(0) || 0), 1)
      ])
    ])
  ]))
}
}

})